<template>
    <div class="container">
        <div class="sportWrapper">
            <div class="sportLeft">
                <peopleData :dataObj="totalData"></peopleData>

                <peopleData :dataObj="TotalIncome"></peopleData>

                <DataQYWZ :list="tableNjlData" @bindName="bindName" @changeVal="changeVal" @scrollEnd="loadMore">
                </DataQYWZ>
                <chartDataAge></chartDataAge>
            </div>
            <div class="sportCenter">
                <!-- <MapComponent v-if="tableData.length>0" :list="tableData" @handleClickMap="bindName" /> -->
                <GuofuMap :points="points" @handleClickMap="bindName"></GuofuMap>
                <div class="qrCOdebox" v-if="rqCode">
                    <img class="qrCOdeImg" :src="rqCode"  alt="二维码" />
                    <span class="qrCodeText" >评价农家乐</span>
                </div>
            </div>
            <div class="sportRight">
                <peopleData :dataObj="todayData"></peopleData>
                <peopleData :dataObj="thisYearData"></peopleData>
                <peopleData :dataObj="historyData"></peopleData>
                <charPietDataSex></charPietDataSex>
                <touristQYData></touristQYData>
            </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog :visible.sync="centerDialogVisible" custom-class="dialogQy" :show-close="true" destroy-on-close
            close-on-press-escape width="90%" :lock-scroll="false" :modal="false" center :title="popData.name||'农家乐'">
            <div>
                <div class="dialog-title">
                    <span class="dialog-title-left"></span>
                    <span>营收统计</span>
                </div>
                <div class="dialog-text-item">
                    <div>月度收入：<span class="cont-text-span">￥{{popData.monthlyIncome}}</span></div>
                    <div>年度收入：<span class="cont-text-span">￥{{popData.yearlyIncome}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>基本信息</span>
                </div>
                <div class="basicInfo">
                    <div class="basicInfo-item" style="margin-bottom: 20px;">
                        <div class="basicInfo-text">农家乐名称：<span class="cont-text-span">{{popData.name}}</span></div>
                        <div class="basicInfo-text">经营类型：
                            <span v-if="popData.businessType==0" class="cont-text-span">餐饮</span>
                            <span v-if="popData.businessType==1" class="cont-text-span">住宿</span>
                            <span v-if="popData.businessType==2" class="cont-text-span">餐饮及住宿</span>
                        </div>
                        <div class="basicInfo-text">星级类型：
                            <span v-if="popData.starLevel==0" class="cont-text-span">非星级农家乐</span>
                            <span v-if="popData.starLevel==1" class="cont-text-span">星级农家乐</span>
                        </div>
                        <div class="basicInfo-text">法人姓名：<span class="cont-text-span">{{popData.legalPerson}}</span>
                        </div>
                        <div class="basicInfo-text">联系电话：<span class="cont-text-span">{{popData.contactPhone}}</span>
                        </div>
                        <div class="basicInfo-text">联系地址：<span class="cont-text-span">{{popData.address}}</span></div>
                    </div>
                    <div class="basicInfo-item">
                        <div class="basicInfo-text">建筑建成时间：<span
                                class="cont-text-span">{{format(popData.buildTime)}}</span>
                        </div>
                        <div class="basicInfo-text">农家乐投用时间：<span
                                class="cont-text-span">{{format(popData.openTime)}}</span>
                        </div>
                        <div class="basicInfo-text text-top">营业执照：
                            <img class="zsImg" :src="path+popData.businessLicense" />
                        </div>
                        <div class="basicInfo-text text-top">卫生许可证：
                            <img class="zsImg" :src="path+popData.healthPermit" />
                        </div>

                    </div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>农家乐信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>占地面积(㎡)：<span class="cont-text-span">{{popData.landArea}}</span></div>
                    <div>建筑面积(㎡)：<span class="cont-text-span">{{popData.buildArea}}</span></div>
                    <div>客房数量：<span class="cont-text-span">{{popData.roomCount}}</span></div>
                    <div>餐厅座位：<span class="cont-text-span">{{popData.seatCount}}</span></div>
                    <div>员工数量：<span class="cont-text-span">{{popData.employeeCount}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>餐饮标准</span>
                </div>
                <div class="dialog-text-item">
                    <div>餐饮标准：<span class="cont-text-span">{{popData.goodsPrice}} 元/人</span></div>
                </div>
                <div class="dialog-text-item" style="margin-top: 20px;">
                    <div>餐饮说明：<span class="cont-text-span">{{popData.goodsDescribe}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>配套设施信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>停车场：<span class="cont-text-span">{{popData.hasParking==1?'有':'无'}}</span></div>
                    <div>采摘：<span class="cont-text-span">{{popData.hasGarden==1?'有':'无'}}</span></div>
                    <div>娱乐：<span class="cont-text-span">{{popData.hasEntertainment==1?'有':'无'}}</span></div>
                    <div>备注：<span class="cont-text-span">{{popData.facilityRemark}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>消防安全信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>灭火器：<span class="cont-text-span">{{popData.hasFireExtinguisher==1?'有':'无'}}</span></div>
                    <div>消防栓：<span class="cont-text-span">{{popData.hasHydrant==1?'有':'无'}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>客房信息</span>
                </div>
                <div class="roomInfo">
                    <div class="roomInfo-item" v-for="(item,index) in popData.rooms" :key="index">
                        <div class="tet">房型/单价</div>
                        <div class="tet">{{item.name}}/￥{{item.price||0}}</div>
                    </div>
                </div>

                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="巡检记录" name="1"></el-tab-pane>
                    <el-tab-pane :label="`入住情况（当前入住人数：${popData.currentGuests}人）`" name="2"></el-tab-pane>

                </el-tabs>

                <el-table v-if="activeName==1" :data="tcTableData1" class="tableBox" :max-height="370"
                    v-loading="loading" style="width: 100%">
                    <el-table-column align="center" prop="inspectionTime" label="巡检时间"></el-table-column>
                    <el-table-column align="center" prop="inspector" label="巡检人员"></el-table-column>
                    <el-table-column prop="state" label="巡检结果">
                        <template #default="scope">
                            <span v-if="scope.row.result==0">不达标</span>
                            <span v-if="scope.row.result==1">达标</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" label="操作">
                        <template #default="scope">
                            <el-button size="mini" type="text" @click="bindInfo(scope.row)"><span
                                    class="voper-pr">详情</span></el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- <el-table v-if="activeName==2" :data="tcTableData2" class="tableBox" :max-height="370"
                    v-loading="loading" style="width: 100%">
                    <el-table-column align="center" prop="roomName" label="入住房型"></el-table-column>
                    <el-table-column align="center" prop="roomPrice" label="单价"></el-table-column>
                    <el-table-column align="center" label="入住时间">
                        <template #default="scope">
                            <span>{{scope.row.checkInTime}}至<br />{{scope.row.checkOutTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="guestName" label="入住客人">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">{{item.guestName}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="idCard" label="身份证号">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">{{item.idCard}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="idCardPhoto" label="身份证图片">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">
                                <img :src="path+item.idCardPhoto" class="idCardPhoto" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="birthDate" label="出生日期">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">{{item.birthDate}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="age" label="年龄">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">{{item.age}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gender" label="性别">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">
                                <span v-if="scope.row.gender==1">男</span>
                                <span v-else>女</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="address" label="住址">
                        <template #default="scope">
                            <div v-for="(item,index) in scope.row.guests" :key="index">{{item.address}}</div>
                        </template>
                    </el-table-column>
                </el-table> -->
                <el-pagination class="paginationBox" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
                    :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
                </el-pagination>


            </div>


        </el-dialog>

        <DataXjInfo ref="refDataXjInfo"></DataXjInfo>
    </div>
</template>

<script>
    import echarts from "echarts";
    import drawMixin from "@/utils/drawMixin";
    import DataQYWZ from "./components/DataQYWZ"; // 农家乐
    import chartDataAge from "./components/chartDataAge"; // 年龄段分布
    import peopleData from "./components/peopleData"; // 今日游客数
    import charPietDataSex from "./components/charPietDataSex"; // 性别分布
    import touristQYData from "./components/touristQYData"; // 游客区域
    import MapComponent from './components/Map.vue';
    import DataXjInfo from "./components/DataXjInfo"; // 巡查详情 弹窗
    import GuofuMap from './components/GuofuMap.vue';



    import { dpGetBasic, agritainmentList, detail, getInspectionsByAgritainment, getAgritainmentGuestList, pageList, fixedRatingQrCode } from '@/api/common.js'

    import {
        formatTime
    } from "@/utils/index.js";

    export default {
        // mixins: [drawMixin],
        data() {
            return {
                totalData: {
                    title: '总农家乐数',
                    num: 0,
                    unit: '家'
                }, // 总农家乐数
                TotalIncome: {
                    title: '小镇农家乐年度总收入',
                    num: 0,
                    unit: '元'
                }, // 
                todayData: {
                    title: '今日游客数',
                    num: 0,
                    unit: '人'
                },
                thisYearData: {
                    title: '今年总游客数',
                    num: 0,
                    unit: '人'
                },
                historyData: {
                    title: '历史总游客数',
                    num: 0,
                    unit: '人'
                },
                centerDialogVisible: false, // 
                roomList: [
                    { name: '单人间/￥99.00' },
                    { name: '大床房/￥199.00' },
                    { name: '豪华间房/￥199.00' },
                    { name: '标准间/￥99.00' },
                    { name: '特价房/￥199.00' },
                    { name: '豪华间房/￥199.00' },

                ],
                activeName: '1',
                tableData: [],
                points: [], // 地图数据
                total: 0,
                queryNjlParams: {
                    pageNum: 1,
                    pageSize: 10,
                },
                tableNjlData: [],
                tableNjlTotal: 0,
                queryParams: {
                    pageNum: 1,
                    pageSize: 5,
                },
                loading: false,
                tcTableData1: [],
                tcTableData2: [],
                popData: {},
                path: process.env.VUE_APP_BASE_API,
                rqCode: '', // 二维码
            };
        },
        components: {
            DataQYWZ, chartDataAge, peopleData, charPietDataSex, touristQYData, DataXjInfo,
            MapComponent, GuofuMap
        },
        created() { },
        mounted() {
            this.init()
            this.getList()
            this.getNjlList()
            this.getQrCode()
        },
        beforeDestroy() {

        },

        methods: {
            async getQrCode() {
                let res = await fixedRatingQrCode()
                if (res.code == 200) {
                    this.rqCode = this.path + res.data
                    
                }
            },


            formatNumberToArray(num) {
                const str = num.toLocaleString('en-US'); // 转为千分位字符串（如 "1,234,567"）
                const result = [];

                let i = 0;
                while (i < str.length) {
                    // 检查下一个字符是否是逗号，是则合并到当前字符
                    if (i + 1 < str.length && str[i + 1] === ',') {
                        result.push(str[i] + ',');
                        i += 2; // 跳过已处理的逗号
                    } else {
                        result.push(str[i]);
                        i += 1;
                    }
                }
                return result;
            },
            formatNumber(num) {
                const formatted = num.toLocaleString();
                return formatted.split('').map(char => {
                    return char === ',' ? `${char},` : char;
                });

            },
            init() {
                // 
                dpGetBasic().then(res => {
                    if (res.code == 200) {
                        this.totalData.num = this.formatNumberToArray(res.data.asum) // 总农家乐数
                        // this.TotalIncome.num = this.formatNumber(res.data.sumPrice) // 年度总收入
                        this.TotalIncome.num = this.formatNumberToArray(res.data.sumPrice) // 年度总收入

                        this.todayData.num = this.formatNumberToArray(res.data.todayPsum)  // 今日游客数
                        this.thisYearData.num = this.formatNumberToArray(res.data.yearPsum)  // 今年总游客数
                        this.historyData.num = this.formatNumberToArray(res.data.hisPsum)  // 历史总游客数
                    }
                })

            },
            getList() {
                agritainmentList().then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        let points = res.data
                        points.forEach(item => {
                            item.position = [item.longitude, item.latitude]
                        })
                        this.points = points
                    }
                })
            },
            loadMore(val) {
                // console.log('触底回调', val)
                if (this.tableNjlTotal > this.tableNjlData.length) {
                    this.queryNjlParams.pageNum = parseInt(this.queryNjlParams.pageNum) + 1
                    this.$nextTick(() => {
                        this.getNjlList()
                    })
                }

            },
            // 农家乐搜索
            getNjlList() {
                let data = {
                    pageNum: this.queryNjlParams.pageNum,
                    pageSize: this.queryNjlParams.pageSize,
                    name: this.queryNjlParams.name
                }
                pageList(data).then(res => {
                    if (res.code == 200) {
                        this.tableNjlData = this.tableNjlData.concat(res.rows)
                        this.tableNjlTotal = res.total

                    }
                })
            },

            // 搜索
            changeVal(val) {
                // console.log('搜索回调', val)
                if (val == null || val == "") {
                    this.queryNjlParams = {
                        pageNum: 1,
                        pageSize: 10
                    }
                }
                this.queryNjlParams.name = val
                this.tableNjlData = []
                this.tableNjlTotal = 0
                this.$nextTick(() => {
                    this.getNjlList()

                })
            },
            // 点击显示农家乐弹窗
            bindName(val) {
                // console.log(val)
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)'
                });
                detail({ id: val.id }).then(res => {
                    loading.close();
                    if (res.code == 200) {
                        this.activeName = '1'
                        this.centerDialogVisible = true
                        this.popData = res.data
                        this.$nextTick(() => {
                            this.getTable()
                        })
                    } else {
                        this.$message.error(res.msg || '网络错误');
                        return
                    }
                }).catch(err => {
                    loading.close();
                })
            },
            // 巡检和入驻 记录
            getTable() {
                if (this.activeName == '1') {
                    let data = {
                        pageNum: this.queryParams.pageNum,
                        pageSize: this.queryParams.pageSize,
                        agritainmentId: this.popData.id
                    }
                    getInspectionsByAgritainment(data).then(res => {
                        if (res.code == 200) {
                            this.tcTableData1 = res.rows
                            this.total = res.total
                        } else {
                            this.$message.error(res.msg || '网络错误');
                            return
                        }
                    })

                }

                // if (this.activeName == '2') {
                //     let data = {
                //         pageNum: this.queryParams.pageNum,
                //         pageSize: this.queryParams.pageSize,
                //         agritainmentId: this.popData.id
                //     }
                //     getAgritainmentGuestList(data).then(res => {
                //         if (res.code == 200) {
                //             this.tcTableData2 = res.rows
                //             this.total = res.total
                //         } else {
                //             this.$message.error(res.msg || '网络错误');
                //             return
                //         }
                //     })

                // }
            },



            handleClick(tab, event) {
                // console.log(tab);
                // console.log(this.activeName)
                this.queryParams = {
                    pageNum: 1,
                    pageSize: 5,
                }
                this.$nextTick(() => {
                    this.getTable()

                })
            },

            handleSizeChange() {
                this.queryParams.pageSize = val
                this.$nextTick(() => {
                    this.getTable()
                })
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum = val
                this.$nextTick(() => {
                    this.getTable()
                })
            },
            // 格式化
            format(date) {
                let time = new Date(date)
                const year = time.getFullYear();
                const month = (time.getMonth() + 1).toString().padStart(2, '0');
                const day = time.getDate().toString().padStart(2, '0');
                let hour = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
                let min = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
                let ss = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()

                const formattedDate = `${year}-${month}-${day}`;
                // const formattedDate = `${year}-${month}-${day} ${hour}:${min}:00`;
                return formattedDate
            },
            // 
            // 点巡检详情
            bindInfo(row) {
                // console.log(row)
                this.$refs.refDataXjInfo.init(row);
            },

        },
    };
</script>

<style lang="scss" scoped>
    /* @import "../../assets/scss/index.scss"; */

    .container {
        width: 100%;
        height: 980px;
        display: flex;
        padding: 10px;
        padding: 10px 20px;
        /* border-top: 1px solid #707070; */
        padding-top: 0;
        margin-top: 10px;

        .sportWrapper {
            width: 100%;
            display: flex;

            .sportLeft {
                width: 520px;
                /* width: 27%; */
                padding-bottom: 33px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                /* border: 1px solid #fafafa; */

            }

            .sportCenter {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 10px;
                /* background: gray; */
                position: relative;
                overflow: hidden;
                z-index: 0;

                .qrCOdebox {
                    width: 120px;
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    z-index: 10;

                }

                .qrCOdeImg {
                    width: 120px;
                    height: 120px;

                }
            }

            .sportRight {
                width: 520px;
                /* width: 27%; */
                /* background: red; */
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding-bottom: 33px;
            }

            .topBackg {
                width: 229px;
                height: 34px;
                margin: 0 auto;
                font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                font-weight: bold;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                background-image: url('../../assets/home/topBackg.png');
                line-height: 34px;
                letter-spacing: 0;
                font-style: normal;
                text-transform: none;
                margin-bottom: 10px;
            }
        }

        ::v-deep .dialogQy {
            background: #2D4E8A;

            .el-dialog__header {
                padding: 15px 0;
                background: #5275B5;

                .el-dialog__title {
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 24px;
                    color: #FFFFFF;
                }

                .el-dialog__headerbtn {
                    .el-dialog__close {
                        color: #fff;
                        font-size: 24px;
                    }
                }
            }

            .el-dialog__body {
                padding: 15px;
                max-height: 817px;
                box-sizing: border-box;
                overflow-y: auto;

                .dialog-title {
                    display: flex;
                    align-items: center;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 16px;
                    color: #9CD8FF;
                    margin-bottom: 15px;

                    .dialog-title-left {
                        width: 3px;
                        height: 20px;
                        background: #9CD8FF;
                        border-radius: 6px;
                        margin-right: 10px;
                    }
                }

                .dialog-text-item {
                    display: flex;
                    align-items: center;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 16px;
                    color: #BDD9EC;

                    .cont-text-span {
                        color: #FFFFFF;
                        margin-left: 20px;
                        margin-right: 60px;
                    }


                }

                .basicInfo {
                    .basicInfo-item {
                        display: flex;
                        font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                        font-weight: normal;
                        font-size: 16px;
                        color: #BDD9EC;

                        .basicInfo-text {
                            width: 15%;

                        }

                        .basicInfo-text:last-child {
                            width: 25%;
                        }

                        .cont-text-span {
                            color: #FFFFFF;
                            margin-left: 10px;
                        }

                        .zsImg {
                            width: 120px;
                            height: 80px;
                            background: #C4C4C4;
                            margin-left: 10px;
                        }

                        .text-top {
                            display: flex;
                            align-items: start;
                        }
                    }
                }

                .roomInfo {

                    .roomInfo-item {
                        display: inline-flex;
                        align-items: center;
                        width: 33%;
                        text-align: center;
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: 16px;
                        color: #FFFFFF;

                        .tet {
                            flex: 1;
                            height: 52px;
                            background: #5275B5;
                            border: 1px solid #8AB9FC;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }

                .el-tabs {
                    .el-tabs__item {
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: 16px;
                        color: #738CB2;
                    }

                    .is-active {
                        color: #0099FF;
                    }

                    .el-tabs__nav-wrap::after {
                        background-color: #738CB2 !important;
                    }
                }


            }







            .dialog-titel-item {
                display: flex;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                margin-bottom: 10px;

                .child1 {
                    flex: 0.4,
                }

                .child2 {
                    flex: 0.6,
                }
            }

            .deatl {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 18px;
            }

            .el-dialog__footer {
                padding-bottom: 10px;
            }

            .dialog-footer {

                .footer-btn {
                    width: 116px;
                    border-radius: 0;
                    background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
                    border: 1px solid #9FD9FF;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #9FD9FF;
                }
            }
        }

        .mTop40 {
            margin-top: 40px;
        }

        ::v-deep .tableBox {
            background: none;

            tr {
                background: none;

                th {
                    background: none;
                    color: #D8E7FF;
                }

                td {
                    border: none;
                    border-bottom: 1px solid #4A72A2;
                    border-left: none;
                    border-right: none;
                    font-size: 16px;
                }
            }

            .has-gutter {
                border: 1px solid #9FD9FF;
            }

            .el-table__header-wrapper {
                border: 1px solid #9FD9FF;
            }

            .is-leaf {
                border: none;
            }

            .el-table__row {

                /* border: 1px solid #4A72A2; */
            }

            .el-table__cell {
                /* border: none; */
                border-left: none;
                border-right: none;
            }

            .el-table__header-wrapper {
                /* background: linear-gradient(180deg, #02265B 0%, #34639A 100%); */
                background: #5275B5;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #D8E7FF;
            }

            .el-table__row:nth-child(2n) {
                /* background: linear-gradient(180deg, #1F4277 0%, #34639A 100%); */
                background-color: #2D4E8A;
            }

            .el-table__row {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 18px;
                color: #BFDDFF;
            }

            .even-row {
                background: none !important;

            }

            .el-table__row:hover {
                background: none !important;
                /* 设置悬停时的背景色 */
            }


        }

        ::v-deep .el-table::before {
            background: none;
        }

        /* 鼠标移入某一行的样式 */
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background: #2D4E8A;
        }

        ::v-deep .el-table__body tr.current-row>td.el-table__cell {
            background-color: #2D4E8A;
        }

        .voper-pr {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #57A9FB;
        }


        ::v-deep .paginationBox {
            text-align: right;
            margin-top: 24px;

            .el-pagination__total {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #B8D1F0;
            }

            .btn-prev,
            .btn-next {

                border-radius: 4px 4px 4px 4px;
                border: 1px solid #849FC5;
                background: none;
                color: #fff;
            }

            .el-pager {
                .number {
                    background: none;
                    color: #B8D1F0;
                }

                .active {
                    background: #1374FF;
                    color: #B8D1F0;
                }
            }

            .el-pagination__jump {
                color: #B8D1F0;

                .el-input__inner {
                    background: none;
                    color: #fff;
                }
            }

        }

        .idCardPhoto {
            width: 60px;
            height: 35px;
        }
    }
</style>